import { FollowUpRoot } from './followupmapsearchresults.model';
import { RootObject, Extension, Feature, MapNote } from './mapsearchresults.model';
import { ServiceAreaCodes, CallerSuppliedGeometry } from './map.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import * as ol from 'openlayers';

import { HttpHeaders } from '@angular/common/http/src/headers';
import { CountyPlace } from './searchcountyplace.model';

/**
 * @description
 * @class
 */
@Injectable()
export class MapService {

  private mapurl = 'api/Map';

  constructor(private router: Router, private httpclient: HttpClient) {

  }

  ticketCodes = new ServiceAreaCodes();

  getServiceAreaCodes(geometry: string, token: string, state: string ){
      return new Promise<ServiceAreaCodes>(resolve => {
        this.httpclient.get<ServiceAreaCodes>(`${this.mapurl}/getcodes`, {
            params: { geometryWKT: geometry, gctoken: token, state: state }
        })
            .subscribe(data => {
                this.ticketCodes = data;
                resolve(this.ticketCodes);
            });
        setTimeout(() => resolve(this.ticketCodes), 30000);
    });
  }



  getSearchResults(county: string, place: string, streetAddress: string, streetPrefix: string, streetName: string, streetType: string, streetSuffix: string, intersection: string, gcToken: string, state: string): Observable<RootObject>{
    return this.httpclient.get<RootObject>(`${this.mapurl}/getsearchresults?county=${county}&place=${place}&streetAddress=${streetAddress}&streetPrefix=${streetPrefix}&streetName=${streetName}&streetType=${streetType}&streetSuffix=${streetSuffix}&intersection=${intersection}&gcToken=${gcToken}&state=${state}`);
  }

  getFollowUpSearchResults(county: string, place: string, streetAddress: string, streetPrefix: string, streetName: string, streetType: string, streetSuffix: string, intersection: string, gcToken: string, url: string, state: string): Observable<FollowUpRoot>{
    return this.httpclient.get<FollowUpRoot>(`${this.mapurl}/getfollowupsearchresults?county=${county}&place=${place}&streetAddress=${streetAddress}&streetPrefix=${streetPrefix}&streetName=${streetName}&streetType=${streetType}&streetSuffix=${streetSuffix}&intersection=${intersection}&gcToken=${gcToken}&followup=${url}&state=${state}`);
  }

  getCounty(gcToken: string, state: string): Observable<CountyPlace>{
    return this.httpclient.get<CountyPlace>(`${this.mapurl}/getcounty?gcToken=${gcToken}&state=${state}`);
  }

  getPlace(gcToken: string, county: string, state: string): Observable<CountyPlace>{
    return this.httpclient.get<CountyPlace>(`${this.mapurl}/getcountyplace?gcToken=${gcToken}&county=${county}&state=${state}`);
  }

  getBingSearchResults(county: string, place: string, streetAddress: string, streetPrefix: string, streetName: string, streetType: string, streetSuffix: string, intersection: string, gcToken: string, searchType: string, state: string): Observable<Feature[]>{
    return this.httpclient.get<Feature[]>(`${this.mapurl}/getbingstreet?county=${county}&place=${place}&streetAddress=${streetAddress}&streetPrefix=${streetPrefix}&streetName=${streetName}&streetType=${streetType}&streetSuffix=${streetSuffix}&intersection=${intersection}&gcToken=${gcToken}&searchType=${searchType}&state=${state}`);
  }

  getCallerSuppliedPoints(gcToken: string, gcNumber: string, state: string) {
    return this.httpclient.get<CallerSuppliedGeometry[]>(`${this.mapurl}/getcallersuppliedgeometry?gcToken=${gcToken}&gcNumber=${gcNumber}&state=${state}`);
  }

  getBaseVersion(key: string, gcToken: string, state: string) {
   return this.httpclient.get(`${this.mapurl}/getbaseversion?key=${key}&gcToken=${gcToken}&state=${state}`);
  }

  getMapNotes = (gcToken: string, state: string, longitude: number, latitude: number): Observable<MapNote[]> => {
    const [transformedLongitude, transformedLatitude] = ol.proj.transform([longitude, latitude], 'EPSG:4326', 'EPSG:3857');

    return new Observable<MapNote[]>(observer => {
      this.httpclient.get(`${this.mapurl}/getmapnotes?gcToken=${gcToken}&state=${state}&longitude=${transformedLongitude}&latitude=${transformedLatitude}`).subscribe(response => {
        const xmlDoc = new DOMParser().parseFromString(response.toString(), "text/xml");
        const mapNotesNode = xmlDoc.documentElement.getElementsByTagName('ms:MapNote');
        const mapNotes: MapNote[] = [];

        for (let x = 0; x < mapNotesNode.length; x++) {
          const mapNoteNode = mapNotesNode[x];
          const mapNote: MapNote = new MapNote();

          for (let y = 0; y < mapNoteNode.children.length; y++) {
            const childNode = mapNoteNode.children[y];
            const nodeName = childNode.nodeName

            if (nodeName === 'ms:msGeometry') {
              const gpsString = childNode.getElementsByTagName('gml:coordinates')[0].childNodes[0].nodeValue;
              const matches = gpsString.match(/^(-?\d*.?\d*),(-?\d*.?\d*)$/);

              mapNote.longitude = +matches[1];
              mapNote.latitude  = +matches[2];
            }
            else {
              const nodeValue = childNode.childNodes[0] ? childNode.childNodes[0].nodeValue : undefined;

              if (nodeName === 'ms:mapnoteid') mapNote.id      = +nodeValue;
              if (nodeName === 'ms:name')      mapNote.name    =  nodeValue;
              if (nodeName === 'ms:remarks')   mapNote.remarks =  nodeValue;
            }
          }

          mapNotes.push(mapNote);
        }

        observer.next(mapNotes);
        observer.complete();
      });
    });
  }

  getGoogleSearchResults = (input: string, sessionToken: google.maps.places.AutocompleteSessionToken): Observable<google.maps.places.AutocompletePrediction[]> => {
    return new Observable<google.maps.places.AutocompletePrediction[]>(observer => {
      new google.maps.places.AutocompleteService().getPlacePredictions({input, sessionToken}, (response, status) => {
        observer.next(response || []); // Empty array if no results found
        observer.complete();
      });
    });
  }
}
